var hp = hp || {};
hp.swipers = hp.swipers || {};
(function () {
	// START Online Opinion insert psuedo-tab
	var ooDiv = document.createElement('div');
	ooDiv.id = "vzw_oo_tab";
	ooDiv.className = "vzw_oo_tab_right";
	ooDiv.tabindex = 0;
	ooDiv.setAttribute("aria-label","Activate to launch comment card");
	ooDiv.innerHTML = '<div></div><span></span>';
	ooDiv.onclick = function(){$('#oo_tab').click()};
	document.body.appendChild(ooDiv);
	// END Online Opinion insert psuedo-tab

  $("main").on("keydown", function (e) {
    if (e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 32) {
      $("body").addClass("isKeyboardUser");
    }
  });
  $(window).bind('orientationchange', function (event) {
    location.reload(true);
  });
  $(".video-slide-swipe-scene7-variation>a").click(function(event){
    // console.log("gi");
    $(this).closest('.video-slide-swipe-scene7-variation').find("video")[0].play();
    $(".video-slide-swipe-scene7-variation>a")[0].style.display="none";
    $(this).closest('.video-slide-swipe-scene7-variation').find("video")[0].controls=true;

  });
  // event handler to allow click of accessory tile to go to PDP
  $('.swiper-slide.tech-store img').off('click').on('click',function(){
		location.href = $(this).parents('.swiper-slide.tech-store').find('a.tech-store-brand-name').attr('href')
	})
      
  /* Lazy Loading code STARTS */
  var lh = [];
  var noLazyLoad = [];
  var processedModuleTotal = 0;
  var wscroll = 0;
  var wh = $(window).height();
  function update_offsets() {
    lh = [];
    $('.container-fluid').each(function () {
    	//console.log('update_offsets',$(this).attr('class'))
      var x = $(this).offset().top;
      lh.push(x);
    });
  };
  function lazy() {
    if (lh.length === processedModuleTotal) { return }
    wscroll = $(window).scrollTop();
    var threshold = wscroll ? 400 : 0;
    for (i = processedModuleTotal; i < lh.length; i++) {
      if (lh[i] <= wscroll + wh + threshold) {
        //console.log(processedModuleTotal, i, lh[i], wscroll + wh + 400);
        lazyLoadComponent($('.container-fluid>div').eq(i));
        processedModuleTotal++;
      };
    };
  };
  update_offsets();
  lazy();// DO NOT REMOVE THIS!!! contact wichmru if you have doubts
  
	var phonesLoaded = false;
  $(window).on('scroll load', function () {
    lazy();
		// START - phones module. Maybe we can improve this
    if(!phonesLoaded && $('.swiper-container.phone-tile-swipe.swiper-container-horizontal .swiper-wrapper').offset()!==undefined){
      var elementTop = $('.swiper-container.phone-tile-swipe.swiper-container-horizontal .swiper-wrapper').offset().top;
      var elementBottom = elementTop +$('.swiper-container.phone-tile-swipe.swiper-container-horizontal .swiper-wrapper').outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      if(elementBottom > viewportTop && elementTop < viewportBottom){
        lazyLoadComponent($('.phoneTile>div'));
        //modifyAltTags();
        $('.shop-phones-image-frame img').attr('alt','')
        phonesLoaded = true;
      }  
    }
    // END - phones module. Maybe we can improve this
  });
  /* Lazy Loading code ENDS */

  function lazyLoadComponent(element){
    // console.log('Lazy element', element)
    if($(element).data('swiper')){
      var swiper_name = $(element).data('swiper');
      // console.log('Lazy load element: ', element.data('swiper') ? swiper_name : 'No swiper found')
      // console.log('Swipers', hp.swipers[swiper_name].init);
      if(typeof hp.swipers[swiper_name] !== 'undefined' && typeof hp.swipers[swiper_name].init === 'function'){
        if(!hp.swipers[swiper_name].initialized){
          hp.swipers[swiper_name].init();
          //If there are multiple instances - eg. the returned value is an array, init only the needed swiper
          //hp.swipers[swiper_name].instances[$('.'+swiper_name.replace('_', '-'), $(element)).data('id')].init();
        }
      }
    }
  	$(element).attr("data-attr-desktop") && addBgTag(element);
    $(element).find("img").attr("data-attr-desktop") && LogoConfigurable(element);
    $(element).find("video").attr("poster-desktop") && PosterConfigurable(element);/*
    $(element).find("img").attr("data-attr-desktop-backgroundImage") && addbackgroundImage(element);*/
  	$(element).find("img").length && addImages(element);
  	$(element).find(".video-slide-swipe, .external-review-swipe-youtube, .video-slide-swipe-SingleVideo,.video-slide-swipe-SingleImage,.html-video-slide-swipe").length && youtubeBgImages($(element).find(".video-slide-swipe, .external-review-swipe-youtube,.video-slide-swipe-SingleVideo,.video-slide-swipe-SingleImage,.html-video-slide-swipe"));
  }
    function PosterConfigurable(element) {
      var $element = $(element);
      var winWidth = $(window).width();
       $(element).find('video').each(function(i,x){
       var dataAttr = winWidth < 768 && $(x).attr("poster-mobile") ? $(x).attr("poster-mobile") : $(x).attr("poster-desktop");
      /* backgroundURL = "url(" + dataAttr + ")";*/
       $(x).attr("poster",dataAttr);;
      });
    }
/*    function addbackgroundImage(element){
      var $element = $(element);
      var winWidth = $(window).width();
      $(element).find('img').each(function(i,x){
      var dataAttr = winWidth < 768 && $(x).attr("data-attr-mobile-backgroundImage") ? $(x).attr("data-attr-mobile-backgroundImage") : $(x).attr("data-attr-desktop-backgroundImage");
       backgroundURL = "url(" + dataAttr + ")";
       $(x).css("background-image", backgroundURL);
     });
    } */ 

  function youtubeBgImages($element){
  	// console.log('youtubeBgImages', $element);
  	var src = '';
  	$element.find('.swiper-slide,.swiper-slide-A').each(function(i,x){
  		if($(x).attr('data-placeholder-src')){
	  		$(x).css('background-image','url('+ $(x).attr('data-placeholder-src') +')');
	  	}else if($(x).find('.video-iframe').attr('data-video-id')){
  			$(x).find('.video-iframe').attr('data-video-id') && $(x).css('background-image','url(https://i.ytimg.com/vi/'+ $(x).find('.video-iframe').attr('data-video-id') +'/hqdefault.jpg)');
  		}else if($(x).hasClass('Youtube-tile') && $(x).find('img').attr('data-src')===''){
  			src = 'https://i.ytimg.com/vi/'+ $(x).find('.image-holding-div').attr('data-video-id') +'/hqdefault.jpg';
  			$(x).find('img').attr('data-src',src).hide().after('<div class="image-background-div" style="background-image:url('+ src +')"></div>');
  		}
  	});
  }

  function addImages(element){
  	//console.log('addImages',$(element))
  	$(element).find('img').each(function(i,x){ 		
  		var srcURL = $(x).attr('data-src'),
  				srcsetURL = $(x).attr('data-srcset');  	 			
  		if(srcURL){
  			//!$(x).attr('src') && console.log(srcURL)
  			var subdomain = srcURL.substring(srcURL.indexOf('//')+2,srcURL.indexOf('.'));
  			if(subdomain.toLowerCase() === 'ss7'){
  				var idx = $(x).closest('.swiper-slide').attr('data-swiper-slide-index');
  				if(idx%4){// this image is in swiper so we append server alias with modulus of the swiper index
						srcURL = srcURL.replace(subdomain,subdomain+idx%4);
						if(srcsetURL){
  						srcsetURL = srcsetURL.replace(subdomain,subdomain+idx%4);
  					}
  				}else if(!idx && i%4){// this image is NOT in swiper so we append server alias with modulus of .each function index
  					srcURL = srcURL.replace(subdomain,subdomain+i%4);
  					if(srcsetURL){
  						srcsetURL = srcsetURL.replace(subdomain,subdomain+i%4);
  					}
  				}
  				
  			}		
	  		//console.log('src=',$(element).find('img').length,i%4,idx,idx%4,srcURL.substr(8,15));
	  		!$(x).attr('src') && $(x).attr('data-src') && $(x).attr('src',srcURL);
	  		
	  		
	  		// Currently we have data-srcset set for tech store which has input for mobile URL but not the complete srcset rule.
	  		// in that case we need to add the rest of the srcset since we only get mobile URL
	  		// This may be better done in AEM code but will leave here for now so we control.
	  		
	  		var count = (srcsetURL && srcsetURL.match(/https/g) || []).length;
	  		// look for single URL in srcsetURL
				if(count==1){
					var srcset = srcsetURL.trim();	
					// now check to see if srcsetURL ends in 'x', if not, we need to process it
					if(srcset.substr(srcset.length - 1) !== 'x'){	
						srcsetURL += ' 767w, ' + srcURL;
					}
				}
				
  			!$(x).attr('srcset') && $(x).attr('data-srcset') && $(x).attr('srcset',srcsetURL);
	  	}	
  	});
  }
  function LogoConfigurable(element) {
     var $element = $(element);
    var winWidth = $(window).width();
     $(element).find('img').each(function(i,x){
     //  var dataAttr = winWidth < 768 && $(x).attr("data-attr-mobile") ? $(x).attr("data-attr-mobile") : $(x).attr("data-attr-desktop");
    var dataAttr = (winWidth < 1024 && $(x).attr("data-attr-tablet") ? (winWidth < 768 && $(x).attr("data-attr-mobile") ? $(x).attr("data-attr-mobile") : $(x).attr("data-attr-tablet")) : (winWidth < 1024 ? (winWidth < 768 ? $(x).attr("data-attr-mobile"): $(x).attr("data-attr-desktop")) : $(x).attr("data-attr-desktop")));
    /* backgroundURL = "url(" + dataAttr + ")";*/
     $(x).attr("src",dataAttr);;
    });
  }
  var backgroundURL = "";
  function addBgTag(element) {
    var $element = $(element);
    var scaleWidth = 1;
    var winWidth = $(window).width();
    //var dataAttr = winWidth < 768 && $element.attr("data-attr-mobile") ? $element.attr("data-attr-mobile") : $element.attr("data-attr-desktop");
    var dataAttr = (winWidth < 1024 && $element.attr("data-attr-tablet") ? (winWidth < 768 && $element.attr("data-attr-mobile") ? $element.attr("data-attr-mobile") : $element.attr("data-attr-tablet")) : (winWidth < 1024 ? (winWidth < 768 ? $element.attr("data-attr-mobile"): $element.attr("data-attr-desktop")) : $element.attr("data-attr-desktop")));
    var checkRetina = matchMedia("(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)").matches;
    if(typeof dataAttr === 'undefined'){return false}
    dataAttr = dataAttr.trim();
    if (checkRetina && false) {// this condition may be defeated for performance
      dataAttr = dataAttr.replace('scl=2', 'scl=1');
      scaleWidth = 2;
    } else {
      dataAttr = dataAttr.replace('scl=1', 'scl=2');
      scaleWidth = 1;
    }
    //console.log($(window).width(),window.innerWidth, $element)

    var appendWidth = winWidth; // scl=2 to be added to S7 params if images are too large
    if (winWidth <= 450) {/* do nothing */ }
    else if (winWidth <= 600) { appendWidth = 600 }
    else if (winWidth <= 768) { appendWidth = 768 }
    else if (winWidth <= 800) { appendWidth = 800 }
    else if (winWidth <= 1024) { appendWidth = 1024 }
    else { appendWidth = 1272 }
    if (dataAttr.indexOf("//ss7") !== -1) {
      if (winWidth < 768 && $element.hasClass('m-align-right')){
      	var crop = (767 - winWidth) * -2
      	backgroundURL = "url(" + dataAttr + "&extend=" + crop + ",0,0,0)";
      }else if (winWidth <= 768 && $element.hasClass('m-align-left')){
      	var crop = (767 - winWidth) * -2
      	backgroundURL = "url(" + dataAttr + "&extend=0,0," + crop + ",0)";
      } else {
      	backgroundURL = "url(" + dataAttr + "&wid=" + appendWidth * scaleWidth + ")";
      }    
    } else {
      backgroundURL = "url(" + dataAttr + ")";
    }

    $element.css("background-image", backgroundURL);

    if (winWidth < 768) {// NEED to validate if this is even current or necessary
      $element.addClass("component-wrapper-mobile");
    } else {
      $element.removeClass("component-wrapper-desktop");
    }

    update_offsets();// need this here cuz TnT code keeps array from having all elements

  }
  function addHeroLogo(element) {
    var $element = $(element);
    var dataAttrMobile = $element.attr("data-attr-mobile");
    var dataAttrDesktop = $element.attr("data-attr-desktop");
    if (dataAttrMobile && $(window).width() < 768) {
      $element.attr('src', dataAttrMobile);
      // backgroundURL = "url(" + dataAttrMobile + ")";
      // $element.css("background-image", backgroundURL);
      // $element.addClass("component-wrapper-mobile");
    } else if (dataAttrDesktop && $(window).width() >= 768) {
      $element.attr('src', dataAttrDesktop);
      // backgroundURL = "url(" + dataAttrDesktop + ")";
      // $element.css("background-image", backgroundURL);
      // $element.removeClass("component-wrapper-desktop");
    }
  }
  function populateBackgroundimage(element) {
    for (var i = 0; i < element.length; i++) {
      addBgTag(element[i])
    }
  }
  function populateHeroLogo(element) {
    for (var i = 0; i < element.length; i++) {
      addHeroLogo(element[i])
    }
  }
  function modifyAltTags(){
	$('[alt]').each(function(){
		var alt = $(this).attr('alt')
		alt = alt.replace('&reg','').replace('<sup>','').replace('</sup>','')
		$(this).attr('alt',alt)
		//console.log(alt)
	})
}
modifyAltTags();
  // populateBackgroundimage($(".component-wrapper"));
  populateHeroLogo($(".heading-img"));
  $(window).resize(function () {
    // populateBackgroundimage($(".component-wrapper"));
    populateHeroLogo($(".heading-img"));
  });

  // Accessibility attributes for swiper
  allySwiper = function (swiper) {
    if ((typeof swiper === 'object') && !(swiper instanceof Array)) {
      swiper = new Array(swiper);
    }
    for (var i = 0; i < swiper.length; i++) {
      var swiperElement = $(swiper[i].$el);
      //swiperElement.find('.swiper-slide').not('.swiper-slide-duplicate').find('.homepage-heading').attr('tabindex', 0);
      //swiperElement.find('.swiper-slide.swiper-slide-duplicate').find('.homepage-heading').attr('tabindex', -1);
      //swiperElement.find('.swiper-slide.swiper-slide-duplicate').find('.homepage-heading').attr('aria-hidden', true);
      swiperElement.find('.swiper-slide').find('svg').attr('focusable', 'false');
      //swiperElement.find('.swiper-slide a').attr('tabindex', 0);
      //swiperElement.find('.swiper-slide a').attr('aria-hidden', false);
      //swiperElement.find('.swiper-slide.swiper-slide-duplicate a').attr('tabindex', -1);
      //swiperElement.find('.swiper-slide.swiper-slide-duplicate a').attr('aria-hidden', true);
    }
  }

  /** Promo Swiper 4 Column [Start] **/
 
  /** Promo Swiper 4 Column [END] **/

  /** Promo Swiper 2 Column [START] **/

  /** Promo Swiper 2 Column [END] **/

  /** Accessory Tile [START] **/
  
  /** Accessory Tile [END] **/

      
  /* THIS CODE GOES WITH REACTIVE SERVICE */
  /** Shop Phones CONDITION [START] **/  

  /** Shop Phones CONDITION [END] **/

  /** Card Module [START] **/
    // if ($('.carousel-module-swipe').length > 0) {
    //   try{
    //     console.log('try loading card-module');
    //     import('../js/Card-Module.js')
    //     .then(function(CardModule){
    //        console.log('Card Module! brao be :)!', CardModule);
    //     }).catch((err)=>{
    //       console.log('Card Module Loading Error: ', err)
    //     });
    //   }catch(e){
    //     console.log('Error, ',e)
    //   }


    // }
    //card module dynamic component test (not working in IE)
  /** Card Module [END] **/
  /* Text Slider Module [START] */

  /* Text Slider Module [END] */
  /** Twitter Module [START] **/
 
  /** Twitter Module [END] **/
  
  
  /** START - load youtube video api if elements are on the page **/
  if($('#youtube-video-component, #videoSlideModule, #videoSlideModuleSingleVideo, .htmlVideoSlideModule').length){
		//console.log('------- load youtube api')
		// Load the IFrame Player API code asynchronously.
	  var tag = document.createElement('script');
	  //tag.type = 'text/javascript';
  	//tag.defer = true;
	  tag.src = "https://www.youtube.com/player_api";
	  var firstScriptTag = document.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	  // Replace the 'ytplayer' element with an <iframe> and
	  // YouTube player after the API code downloads.
	  function onYouTubePlayerAPIReady() {
	    // console.log('-------onYouTubePlayerAPIReady')
	    /* player = new YT.Player('ytplayer', {
	      height: '360',
	      width: '640',
	      videoId: 'M7lc1UVf-VE'
	    });
	    */
	  }

    function stopYouTubeVids(ray, id){
      $.each(ray, function (index, obj ) {
        if(index !== id){
          var vid = document.getElementById(index).contentWindow;
          vid.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
          //obj.stopVideo();
        }
      });
    }

    function stopHtmlVids(ray,id){
      $.each(ray, function (index, obj ) {
        //console.log('stopOtherVids',index)
        if(index !== id){
          var vid = document.getElementById(index);
          vid.pause();
        }
      });
    }

    function stopOtherVids(id){
      stopYouTubeVids(hp.videoRay,id);
      stopHtmlVids(hp.htmlVideoRay,id);
    }

    hp.stopOtherVids = stopOtherVids;

    function initializePlayer(videoId,iframeId){
      //console.log('initializePlayer - videoRay[videoId]',videoId,videoRay[videoId])
      if(window.YT.loaded){
        // console.log('YT loaded',iframeId)
        stopOtherVids(iframeId)
        videoRay[iframeId] = new YT.Player(iframeId, {
          videoId: videoId,
          playerVars: { 'autoplay': 1, 'rel': 0, showinfo: 0 },
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }else{
        // console.log('YT NOT loaded');
        setTimeout(function(){
          initializePlayer(videoId,iframeId)
        },100);
      }
      //console.log('initializePlayer - videoRay[videoId]2',videoId,videoRay[videoId])
    }
	}
  /** END - load youtube video api if elements are on the page **/
  /** video slide Module [START] **/
  //Single Video Module [START]

  //Single video Module [END]
  


  /** html video slide Module [START] **/
  /** html video slide Module [END] **/
  
  
  
  /* Jay youtube Module - START */
  /* Jay youtube Module - END */

  /* New Component Phone Swiper [START]*/
  /* New Component Phone Swiper [ENDS]*/
	

  /* Articles slider Module - START */
  /* Articles slider Module - END */


  /* Video Module - START */


  // var videoEl = $(".hero-video video");
  // var playPause = $('.hero-video .play-pause');

  // for (var i = 0; i < videoEl.length; i++) {
  //   if ($(videoEl[i]).next(".play-pause.now-playing").length > 0) {
  //     videoEl[i].play();
  //   } else {
  //     videoEl[i].pause();
  //   }
  // }
  // playPause.click(function () {
  //   toggleVideo($(this).prev("video"));
  // });
  // videoEl.click(function () {
  //   toggleVideo($(this));
  // });

  // var toggleVideo = function (_this) {
  //   if (_this[0].paused) {
  //     _this[0].play();
  //     playPause.fadeOut(500);
  //     playPause.addClass("now-playing")
  //   } else {
  //     _this[0].pause();
  //     playPause.fadeIn(500);
  //     playPause.removeClass("now-playing")
  //   }
  // }
  // var playVideo = function (videoEl) {
  //   if (videoEl[0] && videoEl.length && videoEl.length > 0 && videoEl[0].nodeName && videoEl[0].nodeName === "VIDEO") {
  //     if (videoEl[0].paused) {
  //       videoEl[0].play();
  //       playPause.fadeOut(500);
  //       playPause.addClass("now-playing")
  //     } else if (videoEl[0].play) {
  //       videoEl[0].pause();
  //       playPause.fadeIn(500);
  //       playPause.removeClass("now-playing")
  //     }
  //   }
  // }
  // On scroll play video
  var _window = $(window);
  var videoEl = $(".hero-video video,.multi-view-hero video");
  var playBtn = $(".hero-video .play-video");
  var closeModal = $(".overlay-container .close-modal");
  var handleTabEnd = $(".overlay-container .handleTabEnd");
  var modalContainer = $(".overlay-container");
  var isInViewport = function (el) {
    var _element = $(el);
    var elementTop = $(_element).offset().top - 200;
    var elementBottom = elementTop + $(_element).outerHeight();
    var viewportTop = _window.scrollTop() + $("#vzw-gn").height();
    var viewportBottom = viewportTop + _window.height() - 400;
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  var viewPortToggleVideo = function (el) {
    var $el = $(el);
    if (isInViewport(el)) {
        if ($el.find("source").length === 0) {
           // custom change for seperate video link for each view
           var winWidth = $(window).width();
           var videoSrc = (winWidth < 1024 && $el.attr("data-attr-tablet") ? (winWidth < 768 && $el.attr("data-attr-mobile") ? $el.attr("data-attr-mobile") : $el.attr("data-attr-tablet")) : (winWidth < 1024 ? (winWidth < 768 ? $el.attr("data-attr-mobile"): $el.attr("data-attr-desktop")) : $el.attr("data-attr-desktop")));
           if(!videoSrc){
             
              videoSrc = $el.attr("data-src");
           }
           // var videoSrc = $el.attr("data-src");
          var $source = $("<source>", { "src": videoSrc, "type": 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"' })
          $el.append($source); 
          el.onended = function(){this.setAttribute('data-ended',true)};
        }
        if(!el.getAttribute('data-ended')){
        	el.play();
        }
        $el.show();
      el.muted = true;
    } else {
     el.pause();
    }
  }

  var path = location.href;
  var getParamValue;
  var validateParam = "video";
  var cookieName = "suppressvideo";
  if (path.indexOf(validateParam) > -1) {
    getParamValue = getParameter(validateParam, path);  
    var cookieVal = getParamValue === 'n' ? 'y' : 'n';
    create_cookie(cookieName, cookieVal, 30, '/');
    var getCookie = retrieve_cookie(cookieName);
    if (getCookie === 'y') {
        $(".hero-video video").remove();
    }
  }else{
    var getCookie = retrieve_cookie(cookieName);
    if (getCookie === 'y') {
        $(".hero-video video").remove();
    }
  }
function getParameter(name, url) {
    if (!url) {
        url = location.href;
    }
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results === null ? null : results[1];
}
function create_cookie(name, value, days2expire, path) {
  var date = new Date();
  date.setTime(date.getTime() + (days2expire * 24 * 60 * 60 * 1000));
  var expires = date.toUTCString();
  document.cookie = name + '=' + value + ';' +
                   'expires=' + expires + ';' +
                   'path=' + path + ';';
}

function retrieve_cookie(name) {
  var cookie_value = "",
    current_cookie = "",
    name_expr = name + "=",
    all_cookies = document.cookie.split(';'),
    n = all_cookies.length;
 
  for(var i = 0; i < n; i++) {
    current_cookie = all_cookies[i].trim();
    if(current_cookie.indexOf(name_expr) == 0) {
      cookie_value = current_cookie.substring(name_expr.length, current_cookie.length);
      break;
    }
  }
  return cookie_value;
}

  $(window).on('load',function(){
      for (var i = 0; i < videoEl.length; i++) {
      viewPortToggleVideo(videoEl[i])
      }
      $(window).on('scroll', function () {
        for (var i = 0; i < videoEl.length; i++) {
          viewPortToggleVideo(videoEl[i])
        }
      });
  })

  playBtn.on("click", function () {
    var _this = $(this);
    // if ($("#s7_videoview_self").length > 0 && window.s7viewers) {
    //   var s7_videoview_Self = new s7viewers.VideoViewer({
    //     "containerId": "s7_videoview_self",
    //     "params": {
    //       "autoplay": "1",
    //       "loop": "1",
    //       "bearing": "fit-vertical",
    //       "posterimage": videoModal.posterimage,
    //       "asset": videoModal.asset,
    //       "serverurl": "https://ss7.vzw.com/is/image/",
    //       "contenturl": "https://ss7.vzw.com/skins/",
    //       "config": "VerizonWireless/VZW_HTML5_Video_social",
    //       "emailurl": "https://ss7.vzw.com/s7/emailFriend",
    //       "videoserverurl": "https://ss7.vzw.com/is/content/",
    //       "config2": "companypreset"
    //     }
    //   });
    //   s7_videoview_Self.setHandlers({
    //     "initComplete": function () {
    //       $("#s7_videoview").hide()
    //       // $(".opacity-layer").hide()
    //     }
    //   });
    //   s7_videoview_Self.init();
    //   return
    // }
    // if (Object.prototype.toString.call(window.s7_videoview_Modal) === "[object HTMLDivElement]" || Object.prototype.toString.call(window.s7_videoview_Modal) !== "[object Object]" && window.s7viewers) {
    //   var s7_videoview_Modal = new s7viewers.VideoViewer({
    //     "containerId": "s7_videoview_Modal",
    //     "params": {
    //       "autoplay": "1",
    //       "loop": "1",
    //       "bearing": "fit-vertical",
    //       "posterimage": videoModal.posterimage,
    //       "asset": videoModal.asset,
    //       "serverurl": "https://ss7.vzw.com/is/image/",
    //       "contenturl": "https://ss7.vzw.com/skins/",
    //       "config": "VerizonWireless/VZW1DHPVIDMODAL",
    //       "emailurl": "https://ss7.vzw.com/s7/emailFriend",
    //       "videoserverurl": "https://ss7.vzw.com/is/content/",
    //       "config2": "companypreset"
    //     }
    //   });
    //   s7_videoview_Modal.setHandlers({
    //     "initComplete": function () {
    //       var vidRatio = $(".overlay-wrapper video").width() / $(".overlay-wrapper video").height();
    //       var wrapperRatio = $(".overlay-wrapper").width() / $(".overlay-wrapper").height();
    //       if (vidRatio < wrapperRatio) {
    //         var videoWidth = 1.8 * $(".overlay-wrapper").height();
    //         $(".overlay-wrapper").width(videoWidth);
    //         $(window).resize(function () {
    //           var videoWidth = 1.8 * $(".overlay-wrapper").height();
    //           $(".overlay-wrapper").width(videoWidth);
    //         });
    //       }
    //     }
    //   });
    //   s7_videoview_Modal.init();
    //   window.s7_videoview_Modal = s7_videoview_Modal;
    // }

    _this.parents(".hero-video").next(".overlay-container").show();
    if (_this.parents(".hero-video").find(".s7videoviewer").length < 1 && _this.parents(".hero-video").next(".overlay-container").find("video")[0]) {
      _this.parents(".hero-video").next(".overlay-container").find("video")[0].play()
      $(".overlay-container button").css("right", ($(".overlay-container video").offset().left - $(".overlay-container .overlay-wrapper").offset().left))
    } else {
      var currentVideo = _this.parents(".hero-video").find("video");
      if (currentVideo && currentVideo[0] && currentVideo[0].pause) {
        currentVideo[0].pause();
      }
    }
    // }
    $("body").css("overflow", "hidden")
  });
  closeModal.on("click", function () {
    var _this = $(this);
    _this.parents(".overlay-container").find("video")[0].pause()
    $(this).parents(".overlay-container").hide();
    $("body").css("overflow", "inherit")
    var backgroundVideo = _this.parents(".overlay-container").prev().find("video");
    if (backgroundVideo && backgroundVideo[0] && backgroundVideo[0].play && !gnav.mobilecheck()) {
      backgroundVideo[0].play();
    }
  });
  handleTabEnd.on("focus", function () {
    closeModal.focus()
  })
  $('.homepage-anchor-contactRep').on("keyup", function(event) {
    event.preventDefault();
    if (event.keyCode === 13) {
      $('.homepage-anchor-contactRep').click();             
   }  
  });
  
  var formURL;
  if (window.location.origin === "https://testman.verizonwireless.com") {
      formURL="https://testman.verizonwireless.com/one-digital/home/business.form.json";
  }
  else if (window.location.origin === "https://www.verizonwireless.com" || window.location.origin === "https://es.verizonwireless.com"){
    formURL="https://www.verizonwireless.com/one-digital/home/business.form.json";
  }
  else{
    formURL="/content/wcms/one-digital/home/business.form.json";
  }
  
//MyV app modal implementation starts

$('.download-myV-modal').on('click', function(e){
  var iframeSrc = '';
  if(window.location.origin.indexOf('localhost')===-1){
    iframeSrc = '/content/wcms/overlays/MyVApp.html';
  }
  else{
    iframeSrc = './myVModal.html';
  }
  e.stopPropagation();
      if(gnav.mobilecheck()){         
       window.location.href = "https://www.verizonwireless.com/solutions-and-services/my-verizon-mobile/"
      } 
      else{     
        e.preventDefault();
      window.saveMyTarget = e.target;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = 'calc(100% - 17px)';  
      var vzPortableOverlay = document.createElement('div');
      vzPortableOverlay.setAttribute('class','vzPortableOverlayDiv');
      vzPortableOverlay.style.zIndex = 99999999999999;
      vzPortableOverlay.innerHTML = '<div style="width:100%; height:100%; z-index:99999999;  position:fixed;background:#000;opacity:0.5;top:0;left:0;right:0;bottom:0;"></div><iframe id="vzPortableIframe" frameborder=0 style="height:540px; z-index:999999999; border:2px solid #ccc; width:685px; left:30%; top:10%;position:fixed;" src=' + iframeSrc + '></iframe>';
      document.body.appendChild(vzPortableOverlay);
      document.querySelector('#vzPortableIframe').contentDocument.body.focus();       
      $('#vzPortableIframe').attr('src',$('#vzPortableIframe').attr('src')+'#myVLanding')
      }
    });
  //MyV app modal implementation ends

   $('.homepage-anchor-contactRep').on("click", function(e) {
   	e.preventDefault();
        $.ajax({
            type: 'GET',
            url: formURL,
            success: function(data) {
								if(typeof data !== 'object'){
		            	data = JSON.parse(data);
		            }
                if (data.ContactRepForm.Pagekey == "HPB") {
                		$('body').addClass('freeze-body');

                    $('.open-contactrep-modal')[0].style.display = 'block';
                    $(".contactrep-heading").html(data.ContactRepForm.Headline);
                    $(".contactrep-assist").html(data.ContactRepForm.Bodyline);
                    $(".contact-rep-button").html(data.ContactRepForm.CTAlabel);
                    $(".thank-you-header").html(data.ContactRepForm.PostHeading);
                    $(".contact-you-shortly").html(data.ContactRepForm.PostBody);
                    $('.modal-content-aa :input:first').focus();
                    $('.contact-rep-button').attr("disabled","disabled");
                    $('.modal-content-aa :input:last').on('keydown', function (e) { 
                        if ($("this:focus") && (e.which == 9)) {
                            e.preventDefault();
                            $('.modal-content-aa :input:first').focus();
                        }                         
                    });
                }
            }
        });
      $('.contact-rep-button').on('keydown', function (e) { 
          if ($("this:focus") && (e.which == 9)) {
              e.preventDefault();
              $('.open-contactrep-form-fields-modal span:first').focus();
          }
      });

    });
   $("body").on("keyup", ".open-contactrep-modal input[type='text'], .open-contactrep-modal input[type='tel']", function() {
   if($("#firstName")[0].value !='' &&  $("#lastName")[0].value !='' && $("#companyName")[0].value !='' && $("#phoneNumber")[0].value !='' && $("#zipCode")[0].value !='' && $("#email")[0].value !='' 
    && $("#city")[0].value !="" && $("#streetAddress")[0].value !=""){
    $('.contact-rep-button').removeAttr("disabled");
    $('.contact-rep-button')[0].style.backgroundColor="black";
   }
   else{
    $('.contact-rep-button')[0].style.backgroundColor="#d8dada";
    $('.contact-rep-button').attr("disabled","disabled");
   }
   });
   $('.open-contactrep-modal-thankyou .close').on("keyup", function(event) {
    if(event.keyCode === 13){
      $('.open-contactrep-modal-thankyou')[0].style.display = 'none';
    }
   });
    $('.open-contactrep-form-fields-modal .close,.open-contactrep-modal-thankyou .close').on("keyup", function(event) {
      event.preventDefault();
        $('body').removeClass('freeze-body');
        if (event.keyCode === 13) {
        $('.homepage-anchor-contactRep').focus();
        $('.open-contactrep-form-fields-modal .close,.open-contactrep-modal-thankyou .close').click();//
        }  
      });
/*    $('.close').on("keyup", function(event) {
      event.preventDefault();
      $('body').removeClass('freeze-body');
      if (event.keyCode === 13) {
         $('.open-contactrep-modal')[0].style.display = 'none';
         $('.form-server-error').html('').removeClass('form-server-error');
          $("#firstName")[0].value="";
          $("#lastName")[0].value="";
          $("#companyName")[0].value="";
          $("#phoneNumber")[0].value="";
          $("#zipCode")[0].value="";
          $("#email")[0].value="";
          $(".text-area")[0].value="";
          $("#state")[0].value="Select";
          $("#streetAddress")[0].value="";
          $("#city")[0].value="";

          $('.email').html("");
          $('.zipCode').html("");
          $('.phoneNumber').html("");
          $('.companyName').html("");
          $('.lastName').html("");
          $('.firstName').html("");
          $('.state').html("");
          $('.text-area-validation').html("");
          $('.homepage-anchor-contactRep').focus();
          $('.city').html(""); 
          $('.streetAddress').html("");        
      }    
    });*/
    $('.open-contactrep-form-fields-modal .close,.open-contactrep-modal-thankyou .close').on("click", function() {
    		$('body').removeClass('freeze-body');
        $('.open-contactrep-modal')[0].style.display = 'none';
        $('.form-server-error').html('').removeClass('form-server-error');
        $("#firstName")[0].value="";
        $("#lastName")[0].value="";
        $("#companyName")[0].value="";
        $("#phoneNumber")[0].value="";
        $("#zipCode")[0].value="";
        $("#email")[0].value="";
        $(".text-area")[0].value="";
        $("#state")[0].value="Select";
        $("#streetAddress")[0].value="";
        $("#city")[0].value="";

        $('.email').html("");
        $('.zipCode').html("");
        $('.phoneNumber').html("");
        $('.companyName').html("");
        $('.lastName').html("");
        $('.firstName').html("");
        $('.state').html("");
        $('.text-area-validation').html("");
        $('.city').html("");
        $('.streetAddress').html("");
        $('.contact-rep-button').attr("disabled","disabled");
        $('.contact-rep-button')[0].style.backgroundColor="#d8dada";
    });
    $('.contact-rep-button-thankYou').on("keyup", function(event) {
        event.preventDefault();
        $('body').removeClass('freeze-body');
        if(event.keyCode === 13){
            $('.homepage-anchor-contactRep').focus();
            $('.open-contactrep-modal-thankyou')[0].style.display = 'none';
            $('.contact-rep-button-thankYou').click();
/*            $("#firstName")[0].value="";
            $("#lastName")[0].value="";
            $("#companyName")[0].value="";
            $("#phoneNumber")[0].value="";
            $("#zipCode")[0].value="";
            $("#email")[0].value="";
            $(".text-area")[0].value="";
            $("#state")[0].value="Select";
            $("#streetAddress")[0].value="";
            $("#city")[0].value="";   

            $('.email').html("");
            $('.zipCode').html("");
            $('.phoneNumber').html("");
            $('.companyName').html("");
            $('.lastName').html("");
            $('.firstName').html("");
            $('.state').html("");
            $('.text-area-validation').html("");
            $('.city').html("");
            $('.streetAddress').html("");*/
        }
    });
    $('.contact-rep-button-thankYou').on("keydown", function(event) {
      event.preventDefault();
      if(event.which == 9){
          $('.close').focus();
        }
    });  
    $('.contact-rep-button-thankYou').on("click", function() {
    	$('body').removeClass('freeze-body');
        $('.open-contactrep-modal')[0].style.display = 'none';
        $('.form-server-error').html('').removeClass('form-server-error');
        $('.open-contactrep-modal-thankyou')[0].style.display = 'none';
        $('.open-contactrep-form-fields-modal .close,.open-contactrep-modal-thankyou .close').click();
/*        $("#firstName")[0].value="";
        $("#lastName")[0].value="";
        $("#companyName")[0].value="";
        $("#phoneNumber")[0].value="";
        $("#zipCode")[0].value="";
        $("#email")[0].value="";
        $(".text-area")[0].value="";
        $("#state")[0].value="Select";
        $("#streetAddress")[0].value="";
        $("#city")[0].value="";*/
    });
     $(".text-area").on("keydown", function(e) {
      if(e.which == 9 && $('.contact-rep-button').attr("disabled")=="disabled"){
          e.preventDefault();
          $('.open-contactrep-form-fields-modal span:first').focus();
      }
     });
    $(".text-area").on("keyup", function() {
      $(".characters-remaining").text("characters remaining  " + (1000 - $(this).val().length));
    });   
    function format(input, format, sep) {
    var output = "";
    var idx = 0;
    for (var i = 0; i < format.length && idx < input.length; i++) {
        output += input.substr(idx, format[i]);
        if (idx + format[i] < input.length) output += sep;
        idx += format[i];
    }

    output += input.substr(idx);

    return output;
    }
    $('#zipCode').keyup(function() {
      var foo = $(this).val().replace(/[a-zA-Z-=+&$!_]/g,"");
      $(this).val(foo);
    });
    $('#phoneNumber').keyup(function() {
        /*var phoneNumber = $("#phoneNumber")[0].value;
        var phoneNumberRgx = /^[a-zA-Z]+$/;
        var phoneNumberResult = phoneNumberRgx.test(phoneNumber);*/
        var phoneNumber = $("#phoneNumber")[0].value;
        var phoneNumberRgx = /[1-9][0-9]{9,14}/;
        var phoneNumberResult = phoneNumberRgx.test(phoneNumber);
 /*$(this).val().lastIndexOf("-")===3 || $(this).val().lastIndexOf("-")===7 */
        if(phoneNumberResult || $(this).val().charAt($(this).val().length-1)=="-"){
          if($(this).val().lastIndexOf("-")!==3 && $(this).val().lastIndexOf("-")!==7){
            var foo = $(this).val().replace(/-/g,"");
                if (foo.length > 0 /*&& phoneNumberResult==false*/) {
                  foo = format(foo, [3,3], "-");
                }
          }
          else{
            if($(this).val().lastIndexOf("-")===3 || $(this).val().lastIndexOf("-")===7){
                     var foo = $(this).val();
                     if (foo.length > 0 /*&& phoneNumberResult==false*/) {
                     foo = format(foo, [3,3], "");
                     }
            }
            else{
                       var foo = $(this).val().replace(/[a-zA-Z-\s|\[|\]={}+()&!@#$%^*_]/g,"");
                      if (foo.length > 0 /*&& phoneNumberResult==false*/) {
                          foo = format(foo, [3,3], "-");
                      }
            }
            
          }
            /*
          else{
             foo = $(this).val().replace(/^[a-zA-Z]+$/g,"");
          }   */         
          $(this).val(foo);
        }
        else{
               var foo = $(this).val().replace(/[a-zA-Z-\s|\[|\]={}+()&!@#$%^*_]/g,"");
              if (foo.length > 0 /*&& phoneNumberResult==false*/) {
                  foo = format(foo, [3,3], "-");
              }  /*
              else{
                 foo = $(this).val().replace(/^[a-zA-Z]+$/g,"");
              }   */         
            $(this).val(foo);
        }

        
    });   
    $('.contact-rep-button').on("click", function() {
        var city=$("#city")[0].value;
        var cityLength=$("#city")[0].value.length;

        var streetAddress=$("#streetAddress")[0].value;
        var streetAddressLength=$("#streetAddress")[0].value.length;
        var streetRegEx = RegExp('([0-9].*[a-zA-Z])|([a-zA-Z].*[0-9])');
        var streetAddressValidation = streetRegEx.test(streetAddress);

        var textArea= $(".text-area")[0].value.length;
				var textAreaValue= $(".text-area")[0].value;
				
        var firstName = $("#firstName")[0].value;
        var firstNameRgx = /^[A-z ]+$/;
        var firstNameResult = firstNameRgx.test(firstName);

        var lastName = $("#lastName")[0].value;
        var lastNameRgx = /^[A-z ]+$/;
        var lastNameResult = lastNameRgx.test(lastName);

        var companyName = $("#companyName")[0].value;
        var companyNameRgx = /^[a-zA-Z0-9 ]+$/;
        var companyNameResult = companyNameRgx.test(companyName);

        var phoneNumber = $("#phoneNumber")[0].value;
        var phoneNumberRgx = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
        var phoneNumberResult = phoneNumberRgx.test(phoneNumber);

        var zipCode = $("#zipCode")[0].value;
        var zipCodeRgx = /^.{5}$/;
        var zipCodeResult = zipCodeRgx.test(zipCode);

        var email = $("#email")[0].value;
        var emailRgx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailResult = emailRgx.test(email);

        var state = $("#state")[0].value;
        
        if(state == "Select"){
          $('.state').html("Please select a State ");
        }else {
            $('.state').html("");
        }

        if (!emailResult) {
            $('.email').html("Please provide a valid Email ");
        } else {
            $('.email').html("");
        }

        if (!zipCodeResult) {
            $('.zipCode').html("Please provide a valid Zip code ");
        } else {
            $('.zipCode').html("");
        }

        if (!phoneNumberResult) {
            $('.phoneNumber').html("Please provide a valid Phone number ");
        } else {
            $('.phoneNumber').html("");
        }

        if (!companyNameResult) {
            $('.companyName').html("Please provide a valid Company name ");
        } else {
            $('.companyName').html("");
        }

        if (!lastNameResult) {
            $('.lastName').html("Please provide a valid Last name ");
        } else {
            $('.lastName').html("");
        }

        if (!firstNameResult) {
            $('.firstName').html("Please provide a valid First name ");
        } else {
            $('.firstName').html("");
        }

        if (cityLength==0) {
            $('.city').html("Please enter your City");
        } else {
            $('.city').html("");
        }

        if (streetAddressLength==0 || !streetAddressValidation) {
            $('.streetAddress').html("Please enter your Street address");
        } else {
            $('.streetAddress').html("");
        }
        if (firstNameResult && lastNameResult && companyNameResult && phoneNumberResult && zipCodeResult && emailResult && (state !== "Select") && (cityLength!==0) && (streetAddressLength!==0))  {
            /*    $.post("www.google.com", {
                  firstName: firstName,
                  lastName: lastName,
                  companyName:companyName,
                  phoneNumber:phoneNumber,
                  zipCode:zipCode,
                  email:email,
                  state:state

                }).complete(function() {
                    console.log("Success");
                    $('.open-contactrep-modal')[0].style.display = 'none';
                    $('.open-contactrep-modal-thankyou')[0].style.display = 'block';
                  });  */
            
            $("#loader").addClass("spinner");   
            if(window.location.origin.indexOf('localhost') === -1){
            	var restURL = '/one-digital/services/contactUs.html',
            			restType = 'POST';
            }else{
            	var restURL = companyName === 'asd' ? '/api/contactRep/contactMeFail.json' : '/api/contactRep/contactMeSuccess.json',
            			restType = 'GET';
            }      
            var pageRegEx = window.location.href.match(/(\w+)(?:\/)$/);
            var pageName = pageRegEx && pageRegEx.length ? pageRegEx[1] : pageRegEx;
            $.ajax({
                url: restURL,
                type: restType,
                dataType: 'JSON',
                data: {
                    firstName: firstName,
                    lastName: lastName,
                    companyName: companyName,
                    streetAddress:streetAddress,
                    city: city,
                    state: state,
                    zipCode: zipCode,
                    emailAddress: email,
                    phoneNumber: phoneNumber,
                    comments: textAreaValue,
                    pageName: pageName
                },
                success: function(response) {
                	if(response.success){
                		$('.form-server-error').html('').removeClass('form-server-error');
                		$('.open-contactrep-modal')[0].style.display = 'none';
                    $('.open-contactrep-modal-thankyou')[0].style.display = 'block';
                    $('body').removeClass('freeze-body');
                    $("#loader").removeClass("spinner");
                	}else{
                    $("#loader").removeClass("spinner");
                		//console.log("response.formErrors",response.formErrors)
                		var errors = response.formErrors,
                				errhtml = '';
                		for (var key in errors) {
                			//console.log(key,errors[key]);
                			errhtml+= '<p>'+errors[key]+'</p>'	
                		}
                    $('.open-contactrep-form-fields-modal .indicates-req-fields').after('<div role="alert" class="form-server-error">'+errhtml+'</div>');
                    window.scrollTo(0,0);
                	}
                }	
            })
        }

    });


    $('.open-contactrep-modal-thankyou .close').on("click", function() {
    	$('body').removeClass('freeze-body');
        $('.open-contactrep-modal-thankyou')[0].style.display = 'none';
    });
    $('.open-contactrep-modal-thankyou .contact-rep-button-thankYou').on("click", function() {
        $('body').removeClass('freeze-body');
        $('.open-contactrep-modal-thankyou')[0].style.display = 'none';
    });
	
  // if (!gnav.mobilecheck() && window.s7viewers) {
  //   var s7_videoview = new s7viewers.VideoViewer({
  //     "containerId": "s7_videoview",
  //     "params": {
  //       "autoplay": "1",
  //       "loop": "1",
  //       "singleclick": "none",
  //       "posterimage": videoBackground.posterimage,
  //       "asset": videoBackground.asset,
  //       "serverurl": "https://ss7.vzw.com/is/image/",
  //       "contenturl": "https://ss7.vzw.com/skins/",
  //       "config": "VerizonWireless/VZW_HTML5_Video_social",
  //       "emailurl": "https://ss7.vzw.com/s7/emailFriend",
  //       "videoserverurl": "https://ss7.vzw.com/is/content/",
  //       "config2": "companypreset"
  //     }
  //   });
  //   s7_videoview.setHandlers({
  //     "initComplete": function (a) {
  //       // debugger
  //       var s7el = $("#s7_videoview");
  //       var el = s7el.parents(".hero-video");
  //       var colorEl = el.find(".video-content");
  //       var opacityEl = el.find(".opacity-layer");
  //       // debugger
  //       if (colorEl.attr('class').indexOf("color_ff") >= 0) {
  //         opacityEl.css("background-color", "#000")
  //       } else if (colorEl.attr('class').indexOf("color_00") >= 0) {
  //         opacityEl.css("background-color", "#fff")
  //       }
  //       // s7el.find("video").width("100%");
  //       // s7el.find("video").height("height");
  //       // $("#s7_videoview").find("video").attr("width","100%")
  //       // $("#s7_videoview").find("video").attr("height","auto")
  //       // $("#s7_videoview").find("video").css({ "top": "0", "width": "100%", "height": "auto", "left": "0" })
  //       // $(".play-video").click()
  //     }
  //   })
  //   s7_videoview.init()
  //   window.s7_videoview = s7_videoview;
  // }

  /* Video Module - END */
  
  // START - Special method to help fix issues in promo colums when copy is too large to fit
  if(window.innerWidth > 767 && window.innerWidth < 1025 ){
  	var $cont = $('.swiper-promotion-container'),
  			$contHH = $cont.find('.homepage-heading');
    $contHH.css({"margin":'0 0 20px','min-height':parseInt($contHH.css('min-height'))-20+'px'})
    $cont.find('.homepage-subheading').css({"margin":"0 0 40px"})
    $cont.each(function(i,x){
    	maxHeight = 0;
    	$(x).find('.homepage-heading').each(function(ii,xx){
    		maxHeight = $(xx).height() > maxHeight ? $(xx).height() : maxHeight;
    		minHeight = parseInt($(xx).css('min-height'))
    	})
    	$(x).find('.homepage-heading').height(maxHeight)

    	maxHeight = 0;
    	$(x).find('.swiper-promo-pannel').each(function(ii,xx){
    		maxHeight = $(xx).height() > maxHeight ? $(xx).height() : maxHeight;
    	})
    	$(x).find('.swiper-promo-pannel').height(maxHeight)
    })
  }
  // END - Special method to help fix issues in promo colums when copy is too large to fit


  // async additon of script to load Helvetica Neue fonts and tracking code from vendor
  /* Commented on 5/11/2020 as there are domain merge issues and we no longer use this font on HP
  var cdn = gnav.runningFromProd ? '//scache3' : '//stcache';
  var neueJS = document.createElement('script');
  neueJS.type = 'text/javascript';
  neueJS.defer = true;
  neueJS.src = cdn + '.vzw.com/omni/common/js/vendor/monotype/helveticaNeue.js';
  (document.getElementsByTagName('body')[0]).appendChild(neueJS);

	*/
  
 /* Hero Banner section start*/
  if($(".new_option_class").length > 0){
    if($(window).width() > 767){
      var sub_heading = $(".new_option_class .hero-subheading-text").detach().addClass("new_option_class");
      $(".new_option_class").parent().parent().children(".row:eq(0)").children(".hero-heading-wrapper").append(sub_heading);   
    }
  }
 /* Hero Banner section end */
  /* Cookie approach for SOI shared cart */
  var getCartId = retrieve_cookie('sharedcartid');
  var prosCartAvail = retrieve_cookie('prospectCartAvailable');
  var showretrievecart = retrieve_cookie('showretrievecart');
  if (getCartId && prosCartAvail !== 'TRUE' && showretrievecart === 'TRUE') {
    $.ajax({
      url: '/onedp/cart?cartId=' + getCartId + '&jsonOnly=true',
      success: function(response) {
        var resp = JSON.parse(response);
        if (resp.status === 200 && resp.statusCode === '00') {
          var devices = resp.payload.sessionData.devices;
          var images = '';
          for (var i = 0; i < devices.length; i++) {
            images += '<div class="image"><div><img src="' + devices[i].deviceImageUrl + '" /></div><div>' + devices[i].displayName + '</div></div>';
          }
          $('body').append('<div class="overlay-container" id="retrieveCart"><div class="overlay-wrapper"><button aria-label="Close overlay" type="button" class="close-modal close_modal"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 18"><path fill="#000" fill-rule="nonzero" d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></svg></button><div class="title">Hi, there!</div><div class="body"><h2>Welcome back,</h2><p>We have notified the below products in your cart. Do you want to continue where you left ?</p><div class="images"></div><div class="buttons"><a href="/onedp/cart" class="button">Yes, I want to continue</a></div></div></div></div>');
          var retrieveCartModal = $("#retrieveCart");
          retrieveCartModal.find('.images').append(images);
          retrieveCartModal.find('.close_modal').click(function() {
            retrieveCartModal.hide();
          });
          retrieveCartModal.show();
        }
      },
    });
  }
})();
 /** Hero Swiper [START] **/
 /** Hero Swiper [END] **/  